<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="16"
    height="25"
    viewBox="0 0 16 25"
  >
    <g :fill="active ? '#00afa1' : '#fff'" fill-rule="evenodd">
      <g>
        <g>
          <g>
            <g
              transform="translate(-29 -273) translate(11 196) translate(0 62)"
            >
              <use
                fill="#000"
                filter="url(#9kmi47fc1a)"
                xlink:href="#ga4hmyd37b"
              />
              <use fill="#00AFA1" xlink:href="#ga4hmyd37b" />
            </g>
            <g :fill="active ? '#fff' : '#00afa1'" fill-rule="nonzero">
              <g>
                <path
                  fill-opacity=".25"
                  d="M6.32 0C3.731 0 1.626 2.105 1.626 4.692S3.732 9.384 6.32 9.384s4.692-2.105 4.692-4.692S8.906 0 6.32 0zM9.088 10.372H3.55c-1.957 0-3.55 1.592-3.55 3.55v6.958c0 1.175.956 2.13 2.13 2.13h4.115c-.68-.985-1.08-2.18-1.08-3.465 0-3.37 2.742-6.112 6.112-6.112.462 0 .912.051 1.345.149-.172-1.799-1.69-3.21-3.534-3.21z"
                  transform="translate(-29 -273) translate(11 196) translate(0 62) translate(18 15)"
                />
                <path
                  d="M11.277 14.853c-2.587 0-4.692 2.104-4.692 4.692 0 2.587 2.105 4.692 4.692 4.692s4.692-2.105 4.692-4.692-2.105-4.692-4.692-4.692zm1.687 5.402h-.977v.977c0 .392-.318.71-.71.71-.392 0-.71-.318-.71-.71v-.977H9.59c-.392 0-.71-.318-.71-.71 0-.392.318-.71.71-.71h.977v-.978c0-.392.318-.71.71-.71.392 0 .71.318.71.71v.978h.977c.393 0 .71.318.71.71 0 .392-.317.71-.71.71z"
                  transform="translate(-29 -273) translate(11 196) translate(0 62) translate(18 15)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    active: Boolean
  }
}
</script>
